import { render, staticRenderFns } from "./ITWinBimCompare.vue?vue&type=template&id=a6462ebe&scoped=true"
import script from "./ITWinBimCompare.vue?vue&type=script&lang=js"
export * from "./ITWinBimCompare.vue?vue&type=script&lang=js"
import style0 from "./ITWinBimCompare.vue?vue&type=style&index=0&id=a6462ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6462ebe",
  null
  
)

export default component.exports